import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  #openTimeout = null;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    if (this.#openTimeout) clearTimeout(this.#openTimeout);
  }

  #handleCartAdd = (event) => {
    if (!this.hasAttribute('auto-open')) return;

    // 清除上一个未执行的 timeout，防止多次叠加
    if (this.#openTimeout) clearTimeout(this.#openTimeout);

    if (event?.detail?.data?.didError) {
      this.showDialog();
      return;
    }

    this.#openTimeout = setTimeout(() => {
      this.#openTimeout = null;
      this.showDialog();
    }, 400);
  };

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
